import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689d1936"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "newsItem" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "display-2 mt-4 mb-4 postHeadline" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "returnHome row justify--center" }
const _hoisted_11 = { class: "md3 flex" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Tilbage til forside")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LandsHolds = _resolveComponent("LandsHolds")!
  const _component_OfficialMembers = _resolveComponent("OfficialMembers")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error || _ctx.postData.postStatus === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isSlugSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_LandsHolds, {
                    landsHoldsType: _ctx.selectedSlug,
                    postData: _ctx.postData
                  }, null, 8, ["landsHoldsType", "postData"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.postData.postTitle), 1),
                  (_ctx.isOfficialMembers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_OfficialMembers, { selectedSlugType: _ctx.selectedSlug }, null, 8, ["selectedSlugType"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "postContent mb-4",
                    innerHTML: _ctx.postData.postContents
                  }, null, 8, _hoisted_9)
                ])),
            _createVNode(_component_va_divider),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
  ]))
}